(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const phoneBar = event.target.closest('.header--on') && window.matchMedia('(max-width: 1023px)').matches;
      const bottom = phoneBar ? 0 : Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('on-collection-filters')) {
    customElements.define(
      'on-collection-filters',
      class OnCollectionFilters extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.toggle = this.querySelector('[data-on-toggle]');
          this.panel = this.querySelector('[data-on-panel]');
          this.form = this.querySelector('[data-on-form]');
          if (!this.toggle || !this.panel || !this.form) return;

          this.mq = window.matchMedia('(min-width: 990px)');
          this.open = false;
          this.timer = null;
          this.abort = null;

          this.onToggle = () => this.setOpen(!this.open);
          this.onClick = (event) => {
            if (event.target.closest('[data-on-close]')) {
              this.setOpen(false);
              return;
            }
            const clear = event.target.closest('[data-on-clear]');
            if (clear) {
              event.preventDefault();
              this.update(clear.getAttribute('href'));
            }
          };
          this.onChange = () => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.update(this.buildUrl()), 250);
          };
          this.onSubmit = (event) => {
            event.preventDefault();
            clearTimeout(this.timer);
            this.update(this.buildUrl());
          };
          this.onKey = (event) => this.keyDown(event);
          this.onMode = () => this.syncMode();
          this.onPop = () => this.update(location.pathname + location.search, false);

          this.toggle.addEventListener('click', this.onToggle);
          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKey);
          this.form.addEventListener('change', this.onChange);
          this.form.addEventListener('submit', this.onSubmit);
          this.mq.addEventListener('change', this.onMode);
          window.addEventListener('popstate', this.onPop);

          this.apply(false);
        }

        disconnectedCallback() {
          if (!this.toggle) return;
          this.toggle.removeEventListener('click', this.onToggle);
          this.removeEventListener('click', this.onClick);
          this.removeEventListener('keydown', this.onKey);
          this.form.removeEventListener('change', this.onChange);
          this.form.removeEventListener('submit', this.onSubmit);
          this.mq.removeEventListener('change', this.onMode);
          window.removeEventListener('popstate', this.onPop);
          document.documentElement.classList.remove('on-filters-lock');
          clearTimeout(this.timer);
          if (this.abort) this.abort.abort();
        }

        /* ---------- Open / close ---------- */
        apply(open) {
          this.open = open;
          this.setAttribute('data-state', open ? 'open' : 'closed');
          this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          this.panel.inert = !open;
          this.syncMode();
        }

        // Below 990px the panel is a modal bottom sheet: lock page scroll and mark it as a dialog
        syncMode() {
          const modal = this.open && !this.mq.matches;
          document.documentElement.classList.toggle('on-filters-lock', modal);
          if (modal) {
            this.panel.setAttribute('role', 'dialog');
            this.panel.setAttribute('aria-modal', 'true');
          } else {
            this.panel.removeAttribute('role');
            this.panel.removeAttribute('aria-modal');
          }
        }

        setOpen(open) {
          if (open === this.open) return;
          this.apply(open);
          requestAnimationFrame(() => {
            if (open && !this.mq.matches) {
              const close = this.panel.querySelector('.on-filters__close');
              if (close) close.focus({ preventScroll: true });
            } else if (!open) {
              this.toggle.focus({ preventScroll: true });
            }
          });
        }

        focusables() {
          return Array.from(
            this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea')
          ).filter((el) => el.getClientRects().length > 0);
        }

        keyDown(event) {
          if (!this.open) return;
          const mobile = !this.mq.matches;

          if (event.key === 'Escape' && (mobile || this.panel.contains(document.activeElement))) {
            event.preventDefault();
            this.setOpen(false);
            return;
          }

          if (event.key === 'Tab' && mobile) {
            const items = this.focusables();
            if (!items.length) return;
            const first = items[0];
            const last = items[items.length - 1];
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }
        }

        /* ---------- Apply filters (Search & Discovery URL parameters, no page reload) ---------- */
        buildUrl() {
          const params = new URLSearchParams();
          new FormData(this.form).forEach((value, key) => {
            if (value !== '' && value !== null) params.append(key, value);
          });
          const base = this.form.getAttribute('action') || location.pathname;
          const query = params.toString();
          return query ? base + '?' + query : base;
        }

        async update(url, push = true) {
          if (this.abort) this.abort.abort();
          this.abort = new AbortController();
          this.classList.add('is-loading');

          try {
            const separator = url.indexOf('?') > -1 ? '&' : '?';
            const response = await fetch(url + separator + 'section_id=' + encodeURIComponent(this.sectionId), {
              signal: this.abort.signal
            });
            if (!response.ok) throw new Error('Request failed: ' + response.status);

            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            this.render(doc);
            if (push) {
              try {
                history.pushState({ onFilters: true }, '', url);
              } catch (historyError) {
                /* the results are already on screen; only the address bar could not be updated */
              }
            }
          } catch (error) {
            if (error && error.name === 'AbortError') return;
            window.location.href = url; // always fall back to a normal page load
            return;
          }
          this.classList.remove('is-loading');
        }

        render(doc) {
          // Product grid
          const grid = this.querySelector('#ProductGridContainer');
          const nextGrid = doc.querySelector('#ProductGridContainer');
          if (grid && nextGrid) grid.innerHTML = nextGrid.innerHTML;

          // Filter options (counts, disabled values, checked state). The scroll position is kept.
          const body = this.querySelector('[data-on-body]');
          const nextBody = doc.querySelector('[data-on-body]');
          if (body && nextBody) {
            const active = document.activeElement;
            const keep =
              active && body.contains(active) && active.name
                ? { name: active.name, value: active.value }
                : null;

            body.innerHTML = nextBody.innerHTML;

            if (keep) {
              const inputs = body.querySelectorAll('input');
              for (let i = 0; i < inputs.length; i++) {
                if (inputs[i].name === keep.name && inputs[i].value === keep.value) {
                  inputs[i].focus({ preventScroll: true });
                  break;
                }
              }
            }
          }

          // Results count (toolbar + "View results" button)
          doc.querySelectorAll('[data-on-sync]').forEach((next) => {
            const current = this.querySelector('[data-on-sync="' + next.getAttribute('data-on-sync') + '"]');
            if (current) current.innerHTML = next.innerHTML;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-activity-links"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('on-activity-links')) {
    customElements.define(
      'on-activity-links',
      class OnActivityLinks extends HTMLElement {
        connectedCallback() {
          this.links = Array.from(this.querySelectorAll('[data-oal-link]'));
          this.slides = Array.from(this.querySelectorAll('[data-oal-slide]'));
          if (!this.links.length || !this.slides.length) return;

          this.current = 0;
          this.handlers = [];

          this.links.forEach((link, index) => {
            const show = () => this.show(index);
            link.addEventListener('pointerenter', show);
            link.addEventListener('focus', show);
            this.handlers.push([link, show]);
          });

          // Theme editor: selecting a block previews its image
          this.onBlockSelect = (event) => {
            const link = event.target.querySelector('[data-oal-link]');
            const index = this.links.indexOf(link);
            if (index > -1) this.show(index);
          };
          this.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          if (!this.handlers) return;
          this.handlers.forEach(([link, show]) => {
            link.removeEventListener('pointerenter', show);
            link.removeEventListener('focus', show);
          });
          this.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        show(index) {
          if (index === this.current || !this.slides[index]) return;

          const previous = this.current;
          this.current = index;

          this.slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === index);
            slide.classList.toggle('is-prev', i === previous);
          });
          this.links.forEach((link, i) => link.classList.toggle('is-active', i === index));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-collection-card-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-card-carousel')) {
    customElements.define(
      'collection-card-carousel',
      class CollectionCardCarousel extends HTMLElement {
        connectedCallback() {
          if (this.hasAttribute('data-stack')) return;

          this.track = this.querySelector('[data-ccc-track]');
          if (!this.track) return;

          this.nav = this.querySelector('[data-ccc-nav]');
          this.prev = this.querySelector('[data-ccc-prev]');
          this.next = this.querySelector('[data-ccc-next]');
          this.thumb = this.querySelector('[data-ccc-thumb]');
          this.frame = null;
          this.drag = null;
          this.suppressClick = false;
          this.settleTimer = null;
          this.restore = null;

          this.onScroll = () => this.schedule();
          this.onPrev = () => this.go(-1);
          this.onNext = () => this.go(1);
          this.onPointerDown = (e) => this.dragStart(e);
          this.onPointerMove = (e) => this.dragMove(e);
          this.onPointerUp = () => this.dragEnd();
          this.onDragStart = (e) => e.preventDefault();
          this.onClickCapture = (e) => {
            if (!this.suppressClick) return;
            e.preventDefault();
            e.stopPropagation();
            this.suppressClick = false;
          };

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('load', this.onScroll, true);
          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('dragstart', this.onDragStart);
          this.track.addEventListener('click', this.onClickCapture, true);
          if (this.prev) this.prev.addEventListener('click', this.onPrev);
          if (this.next) this.next.addEventListener('click', this.onNext);

          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);

          this.update();
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('load', this.onScroll, true);
          this.track.removeEventListener('pointerdown', this.onPointerDown);
          this.track.removeEventListener('dragstart', this.onDragStart);
          this.track.removeEventListener('click', this.onClickCapture, true);
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          this.cancelSettle();
        }

        schedule() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => this.update());
        }

        metrics() {
          const track = this.track;
          const slide = track.querySelector('.ccc-slide');
          if (!slide) return null;

          const styles = getComputedStyle(track);
          const gap = parseFloat(styles.columnGap) || 0;
          return {
            step: slide.getBoundingClientRect().width + gap,
            sign: styles.direction === 'rtl' ? -1 : 1,
            max: track.scrollWidth - track.clientWidth,
            reduce: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          };
        }

        go(direction) {
          const m = this.metrics();
          if (!m) return;

          this.track.scrollBy({
            left: direction * m.sign * m.step,
            behavior: m.reduce ? 'auto' : 'smooth'
          });
        }

        /* ---------- Mouse drag ---------- */
        dragStart(e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (this.track.scrollWidth - this.track.clientWidth <= 2) return;

          this.suppressClick = false;
          this.drag = {
            x: e.clientX,
            scroll: this.track.scrollLeft,
            moved: false,
            lastX: e.clientX,
            lastT: performance.now(),
            velocity: 0
          };

          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);
        }

        dragMove(e) {
          const d = this.drag;
          if (!d) return;

          const dx = e.clientX - d.x;
          if (!d.moved) {
            if (Math.abs(dx) < 5) return;
            d.moved = true;
            this.cancelSettle();
            this.track.classList.add('is-dragging');
            this.track.style.scrollSnapType = 'none';
          }

          const now = performance.now();
          const dt = now - d.lastT;
          if (dt > 0) {
            d.velocity = 0.7 * d.velocity + 0.3 * ((e.clientX - d.lastX) / dt);
            d.lastX = e.clientX;
            d.lastT = now;
          }

          this.track.scrollLeft = d.scroll - dx;
        }

        dragEnd() {
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);

          const d = this.drag;
          this.drag = null;
          if (!d || !d.moved) return;

          const track = this.track;
          track.classList.remove('is-dragging');
          this.suppressClick = true;

          const m = this.metrics();
          if (!m) {
            track.style.scrollSnapType = '';
            return;
          }

          // Snap to the nearest card; a quick flick moves one card further in that direction.
          const velocity = performance.now() - d.lastT > 80 ? 0 : d.velocity;
          const moving = -velocity * m.sign; // > 0 means the scroll position is increasing
          let index = Math.abs(track.scrollLeft) / m.step;
          if (Math.abs(moving) > 0.35) {
            index = moving > 0 ? Math.ceil(index) : Math.floor(index);
          } else {
            index = Math.round(index);
          }
          const target = Math.max(0, Math.min(index * m.step, m.max));

          track.scrollTo({ left: m.sign * target, behavior: m.reduce ? 'auto' : 'smooth' });
          this.settle();
        }

        settle() {
          const track = this.track;
          this.cancelSettle();
          this.restore = () => {
            this.cancelSettle();
            track.style.scrollSnapType = '';
          };
          track.addEventListener('scrollend', this.restore, { once: true });
          this.settleTimer = setTimeout(this.restore, 700);
        }

        cancelSettle() {
          clearTimeout(this.settleTimer);
          this.settleTimer = null;
          if (this.restore) {
            this.track.removeEventListener('scrollend', this.restore);
            this.restore = null;
          }
        }

        update() {
          this.frame = null;
          const track = this.track;
          const max = track.scrollWidth - track.clientWidth;
          const fits = max <= 2;

          if (this.nav) this.nav.hidden = fits;
          if (fits) return;

          const position = Math.min(Math.abs(track.scrollLeft), max);

          if (this.thumb) {
            const width = Math.min(100, Math.max(12, (track.clientWidth / track.scrollWidth) * 100));
            const offset = (position / max) * (100 - width);
            this.thumb.style.setProperty('--ccc-thumb-w', width + '%');
            this.thumb.style.setProperty('--ccc-thumb-x', offset + '%');
          }

          if (this.prev) this.prev.disabled = position <= 2;
          if (this.next) this.next.disabled = position >= max - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-editorial-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('on-editorial-carousel')) {
    customElements.define(
      'on-editorial-carousel',
      class OnEditorialCarousel extends HTMLElement {
        connectedCallback() {
          this.stage = this.querySelector('[data-oec-stage]');
          this.intro = this.querySelector('[data-oec-intro]');
          this.cards = this.querySelector('[data-oec-cards]');
          this.track = this.querySelector('[data-oec-track]');
          if (!this.stage || !this.track) return;

          this.openBtn = this.querySelector('[data-oec-open]');
          this.closeBtn = this.querySelector('[data-oec-close]');
          this.arrows = this.querySelector('[data-oec-arrows]');
          this.prev = this.querySelector('[data-oec-prev]');
          this.next = this.querySelector('[data-oec-next]');

          this.expanded = false;
          this.frame = null;
          this.drag = null;
          this.suppressClick = false;
          this.settleTimer = null;
          this.restore = null;
          this.heightTimer = null;

          this.onOpen = () => this.setExpanded(true);
          this.onClose = () => this.setExpanded(false);
          this.onEscape = (e) => {
            if (e.key === 'Escape' && this.expanded) this.setExpanded(false);
          };
          this.onScroll = () => this.schedule();
          this.onPrev = () => {
            if (this.prev.getAttribute('aria-disabled') !== 'true') this.page(-1);
          };
          this.onNext = () => {
            if (this.next.getAttribute('aria-disabled') !== 'true') this.page(1);
          };
          this.onKeyDown = (e) => this.keyDown(e);
          this.onPointerDown = (e) => this.dragStart(e);
          this.onPointerMove = (e) => this.dragMove(e);
          this.onPointerUp = () => this.dragEnd();
          this.onDragStart = (e) => e.preventDefault();
          this.onClickCapture = (e) => {
            if (!this.suppressClick) return;
            e.preventDefault();
            e.stopPropagation();
            this.suppressClick = false;
          };

          if (this.openBtn) this.openBtn.addEventListener('click', this.onOpen);
          if (this.closeBtn) this.closeBtn.addEventListener('click', this.onClose);
          this.addEventListener('keydown', this.onEscape);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('load', this.onScroll, true);
          this.track.addEventListener('keydown', this.onKeyDown);
          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('dragstart', this.onDragStart);
          this.track.addEventListener('click', this.onClickCapture, true);
          if (this.prev) this.prev.addEventListener('click', this.onPrev);
          if (this.next) this.next.addEventListener('click', this.onNext);

          this.resizeObserver = new ResizeObserver(() => this.schedule());
          this.resizeObserver.observe(this.track);

          this.apply(false);
        }

        disconnectedCallback() {
          if (!this.track) return;
          if (this.openBtn) this.openBtn.removeEventListener('click', this.onOpen);
          if (this.closeBtn) this.closeBtn.removeEventListener('click', this.onClose);
          this.removeEventListener('keydown', this.onEscape);
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('load', this.onScroll, true);
          this.track.removeEventListener('keydown', this.onKeyDown);
          this.track.removeEventListener('pointerdown', this.onPointerDown);
          this.track.removeEventListener('dragstart', this.onDragStart);
          this.track.removeEventListener('click', this.onClickCapture, true);
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          clearTimeout(this.heightTimer);
          this.cancelSettle();
        }

        /* ---------- Open / close ---------- */
        apply(expanded) {
          this.expanded = expanded;
          this.setAttribute('data-state', expanded ? 'expanded' : 'collapsed');
          if (this.intro) this.intro.inert = expanded;
          if (this.cards) this.cards.inert = !expanded;
          if (this.openBtn) this.openBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }

        setExpanded(expand) {
          if (this.expanded === expand) return;

          const stage = this.stage;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          clearTimeout(this.heightTimer);
          stage.style.height = '';
          if (!expand) this.track.scrollTo({ left: 0, behavior: 'auto' });

          if (reduce) {
            this.apply(expand);
          } else {
            // Measure both layouts, then animate the section height between them.
            const first = stage.getBoundingClientRect().height;
            this.setAttribute('data-measuring', '');
            this.apply(expand);
            const last = stage.getBoundingClientRect().height;
            this.apply(!expand);
            stage.style.height = first + 'px';
            void stage.offsetHeight;
            this.removeAttribute('data-measuring');

            this.apply(expand);
            stage.style.height = last + 'px';
            this.heightTimer = setTimeout(() => {
              stage.style.height = '';
            }, 900);
          }

          this.schedule();
          requestAnimationFrame(() => {
            const target = expand ? this.closeBtn : this.openBtn;
            if (target) target.focus({ preventScroll: true });
          });
        }

        /* ---------- Slider ---------- */
        schedule() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => this.update());
        }

        metrics() {
          const track = this.track;
          const slide = track.querySelector('.oec-slide');
          if (!slide) return null;

          const styles = getComputedStyle(track);
          const gap = parseFloat(styles.columnGap) || 0;
          const step = slide.getBoundingClientRect().width + gap;
          if (!step) return null;
          return {
            step,
            sign: styles.direction === 'rtl' ? -1 : 1,
            max: track.scrollWidth - track.clientWidth,
            visible: Math.max(1, Math.floor((track.clientWidth + gap) / step + 0.05)),
            reduce: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          };
        }

        page(direction) {
          const m = this.metrics();
          if (!m) return;
          this.track.scrollBy({
            left: direction * m.sign * m.step * m.visible,
            behavior: m.reduce ? 'auto' : 'smooth'
          });
        }

        keyDown(e) {
          if (!this.expanded) return;
          if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
          const m = this.metrics();
          if (!m) return;

          const behavior = m.reduce ? 'auto' : 'smooth';
          if (e.key === 'ArrowRight') {
            this.track.scrollBy({ left: m.step, behavior });
          } else if (e.key === 'ArrowLeft') {
            this.track.scrollBy({ left: -m.step, behavior });
          } else if (e.key === 'Home') {
            this.track.scrollTo({ left: 0, behavior });
          } else if (e.key === 'End') {
            this.track.scrollTo({ left: m.sign * m.max, behavior });
          } else {
            return;
          }
          e.preventDefault();
        }

        /* ---------- Mouse drag ---------- */
        dragStart(e) {
          if (!this.expanded) return;
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (this.track.scrollWidth - this.track.clientWidth <= 2) return;

          this.suppressClick = false;
          this.drag = {
            x: e.clientX,
            scroll: this.track.scrollLeft,
            moved: false,
            lastX: e.clientX,
            lastT: performance.now(),
            velocity: 0
          };

          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);
        }

        dragMove(e) {
          const d = this.drag;
          if (!d) return;

          const dx = e.clientX - d.x;
          if (!d.moved) {
            if (Math.abs(dx) < 5) return;
            d.moved = true;
            this.cancelSettle();
            this.track.classList.add('is-dragging');
            this.track.style.scrollSnapType = 'none';
          }

          const now = performance.now();
          const dt = now - d.lastT;
          if (dt > 0) {
            d.velocity = 0.7 * d.velocity + 0.3 * ((e.clientX - d.lastX) / dt);
            d.lastX = e.clientX;
            d.lastT = now;
          }

          this.track.scrollLeft = d.scroll - dx;
        }

        dragEnd() {
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);

          const d = this.drag;
          this.drag = null;
          if (!d || !d.moved) return;

          const track = this.track;
          track.classList.remove('is-dragging');
          this.suppressClick = true;

          const m = this.metrics();
          if (!m) {
            track.style.scrollSnapType = '';
            return;
          }

          // Snap to the nearest card; a quick flick moves one card further in that direction.
          const velocity = performance.now() - d.lastT > 80 ? 0 : d.velocity;
          const moving = -velocity * m.sign;
          let index = Math.abs(track.scrollLeft) / m.step;
          if (Math.abs(moving) > 0.35) {
            index = moving > 0 ? Math.ceil(index) : Math.floor(index);
          } else {
            index = Math.round(index);
          }
          const target = Math.max(0, Math.min(index * m.step, m.max));

          track.scrollTo({ left: m.sign * target, behavior: m.reduce ? 'auto' : 'smooth' });
          this.settle();
        }

        settle() {
          const track = this.track;
          this.cancelSettle();
          this.restore = () => {
            this.cancelSettle();
            track.style.scrollSnapType = '';
          };
          track.addEventListener('scrollend', this.restore, { once: true });
          this.settleTimer = setTimeout(this.restore, 700);
        }

        cancelSettle() {
          clearTimeout(this.settleTimer);
          this.settleTimer = null;
          if (this.restore) {
            this.track.removeEventListener('scrollend', this.restore);
            this.restore = null;
          }
        }

        /* ---------- Arrow state ---------- */
        update() {
          this.frame = null;
          const track = this.track;
          const max = track.scrollWidth - track.clientWidth;
          const fits = max <= 2;

          if (this.arrows) this.arrows.hidden = fits;
          if (fits) return;

          const position = Math.min(Math.abs(track.scrollLeft), max);
          if (this.prev) this.prev.setAttribute('aria-disabled', position <= 2 ? 'true' : 'false');
          if (this.next) this.next.setAttribute('aria-disabled', position >= max - 2 ? 'true' : 'false');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('on-featured-collection')) {
    customElements.define(
      'on-featured-collection',
      class OnFeaturedCollection extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-ofc-track]');
          if (!this.track) return;

          this.nav = this.querySelector('[data-ofc-nav]');
          this.prev = this.querySelector('[data-ofc-prev]');
          this.next = this.querySelector('[data-ofc-next]');
          this.thumb = this.querySelector('[data-ofc-thumb]');
          this.frame = null;
          this.drag = null;
          this.suppressClick = false;
          this.settleTimer = null;
          this.restore = null;

          this.onScroll = () => this.schedule();
          this.onPrev = () => {
            if (this.prev.getAttribute('aria-disabled') !== 'true') this.page(-1);
          };
          this.onNext = () => {
            if (this.next.getAttribute('aria-disabled') !== 'true') this.page(1);
          };
          this.onKeyDown = (e) => this.keyDown(e);
          this.onPointerDown = (e) => this.dragStart(e);
          this.onPointerMove = (e) => this.dragMove(e);
          this.onPointerUp = () => this.dragEnd();
          this.onDragStart = (e) => e.preventDefault();
          this.onClickCapture = (e) => {
            if (!this.suppressClick) return;
            e.preventDefault();
            e.stopPropagation();
            this.suppressClick = false;
          };

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('load', this.onScroll, true);
          this.track.addEventListener('keydown', this.onKeyDown);
          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('dragstart', this.onDragStart);
          this.track.addEventListener('click', this.onClickCapture, true);
          if (this.prev) this.prev.addEventListener('click', this.onPrev);
          if (this.next) this.next.addEventListener('click', this.onNext);

          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);

          this.update();
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('load', this.onScroll, true);
          this.track.removeEventListener('keydown', this.onKeyDown);
          this.track.removeEventListener('pointerdown', this.onPointerDown);
          this.track.removeEventListener('dragstart', this.onDragStart);
          this.track.removeEventListener('click', this.onClickCapture, true);
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          this.cancelSettle();
        }

        schedule() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => this.update());
        }

        metrics() {
          const track = this.track;
          const slide = track.querySelector('.ofc-slide');
          if (!slide) return null;

          const styles = getComputedStyle(track);
          const gap = parseFloat(styles.columnGap) || 0;
          const step = slide.getBoundingClientRect().width + gap;
          return {
            step,
            sign: styles.direction === 'rtl' ? -1 : 1,
            max: track.scrollWidth - track.clientWidth,
            visible: Math.max(1, Math.floor((track.clientWidth + gap) / step + 0.05)),
            reduce: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          };
        }

        /* Prev / next buttons: move one "page" of fully visible cards */
        page(direction) {
          const m = this.metrics();
          if (!m) return;
          this.track.scrollBy({
            left: direction * m.sign * m.step * m.visible,
            behavior: m.reduce ? 'auto' : 'smooth'
          });
        }

        /* Keyboard: left/right arrows move one card, Home/End jump to the ends */
        keyDown(e) {
          if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
          const m = this.metrics();
          if (!m) return;

          const behavior = m.reduce ? 'auto' : 'smooth';
          if (e.key === 'ArrowRight') {
            this.track.scrollBy({ left: m.step, behavior });
          } else if (e.key === 'ArrowLeft') {
            this.track.scrollBy({ left: -m.step, behavior });
          } else if (e.key === 'Home') {
            this.track.scrollTo({ left: 0, behavior });
          } else if (e.key === 'End') {
            this.track.scrollTo({ left: m.sign * m.max, behavior });
          } else {
            return;
          }
          e.preventDefault();
        }

        /* ---------- Mouse drag ---------- */
        dragStart(e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (this.track.scrollWidth - this.track.clientWidth <= 2) return;

          this.suppressClick = false;
          this.drag = {
            x: e.clientX,
            scroll: this.track.scrollLeft,
            moved: false,
            lastX: e.clientX,
            lastT: performance.now(),
            velocity: 0
          };

          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);
        }

        dragMove(e) {
          const d = this.drag;
          if (!d) return;

          const dx = e.clientX - d.x;
          if (!d.moved) {
            if (Math.abs(dx) < 5) return;
            d.moved = true;
            this.cancelSettle();
            this.track.classList.add('is-dragging');
            this.track.style.scrollSnapType = 'none';
          }

          const now = performance.now();
          const dt = now - d.lastT;
          if (dt > 0) {
            d.velocity = 0.7 * d.velocity + 0.3 * ((e.clientX - d.lastX) / dt);
            d.lastX = e.clientX;
            d.lastT = now;
          }

          this.track.scrollLeft = d.scroll - dx;
        }

        dragEnd() {
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);

          const d = this.drag;
          this.drag = null;
          if (!d || !d.moved) return;

          const track = this.track;
          track.classList.remove('is-dragging');
          this.suppressClick = true;

          const m = this.metrics();
          if (!m) {
            track.style.scrollSnapType = '';
            return;
          }

          // Snap to the nearest card; a quick flick moves one card further in that direction.
          const velocity = performance.now() - d.lastT > 80 ? 0 : d.velocity;
          const moving = -velocity * m.sign; // > 0 means the scroll position is increasing
          let index = Math.abs(track.scrollLeft) / m.step;
          if (Math.abs(moving) > 0.35) {
            index = moving > 0 ? Math.ceil(index) : Math.floor(index);
          } else {
            index = Math.round(index);
          }
          const target = Math.max(0, Math.min(index * m.step, m.max));

          track.scrollTo({ left: m.sign * target, behavior: m.reduce ? 'auto' : 'smooth' });
          this.settle();
        }

        settle() {
          const track = this.track;
          this.cancelSettle();
          this.restore = () => {
            this.cancelSettle();
            track.style.scrollSnapType = '';
          };
          track.addEventListener('scrollend', this.restore, { once: true });
          this.settleTimer = setTimeout(this.restore, 700);
        }

        cancelSettle() {
          clearTimeout(this.settleTimer);
          this.settleTimer = null;
          if (this.restore) {
            this.track.removeEventListener('scrollend', this.restore);
            this.restore = null;
          }
        }

        /* ---------- UI state ---------- */
        update() {
          this.frame = null;
          const track = this.track;
          const max = track.scrollWidth - track.clientWidth;
          const fits = max <= 2;

          if (this.nav) this.nav.hidden = fits;
          if (fits) return;

          const position = Math.min(Math.abs(track.scrollLeft), max);

          if (this.thumb) {
            const width = Math.min(100, Math.max(12, (track.clientWidth / track.scrollWidth) * 100));
            const offset = (position / max) * (100 - width);
            this.thumb.style.setProperty('--ofc-thumb-w', width + '%');
            this.thumb.style.setProperty('--ofc-thumb-x', offset + '%');
          }

          // Dim (or hide, see data-end) the arrows at the start / end of the track
          if (this.prev) this.prev.setAttribute('aria-disabled', position <= 2 ? 'true' : 'false');
          if (this.next) this.next.setAttribute('aria-disabled', position >= max - 2 ? 'true' : 'false');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('on-footer-newsletter')) {
    customElements.define(
      'on-footer-newsletter',
      class OnFooterNewsletter extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.input = this.querySelector('.on-ft__input');
          this.status = this.querySelector('.on-ft__status');
          if (!this.form || !this.input) return;

          this.setAttribute('data-js', '');
          // the page was reloaded after a normal (non-AJAX) signup: Shopify rendered the success message inside the form
          if (this.querySelector('[data-on-ft-success]')) this.setAttribute('data-state', 'success');
          this.onFocus = () => this.setAttribute('data-open', '');
          this.onInput = () => {
            this.clearMessage();
            this.sync();
          };
          this.onBlur = () => this.sync();
          this.onSubmit = (event) => this.submit(event);

          this.input.addEventListener('focus', this.onFocus);
          this.input.addEventListener('input', this.onInput);
          this.input.addEventListener('blur', this.onBlur);
          this.form.addEventListener('submit', this.onSubmit);
          this.sync();
        }

        disconnectedCallback() {
          if (!this.input) return;
          this.input.removeEventListener('focus', this.onFocus);
          this.input.removeEventListener('input', this.onInput);
          this.input.removeEventListener('blur', this.onBlur);
          this.form.removeEventListener('submit', this.onSubmit);
        }

        // keep the consent text and button open while there is something to subscribe
        sync() {
          const keep = this.input.value.trim() !== '' || this.contains(document.activeElement);
          this.toggleAttribute('data-open', keep);
        }

        message(text, kind) {
          this.status.replaceChildren();
          if (!text) return;
          const p = document.createElement('p');
          p.className = 'on-ft__msg on-ft__msg--' + kind;
          if (kind === 'success') p.setAttribute('data-on-ft-success', '');
          else p.setAttribute('data-on-ft-error', '');
          p.textContent = text;
          this.status.appendChild(p);
        }

        clearMessage() {
          this.input.removeAttribute('aria-invalid');
          this.status.replaceChildren();
        }

        invalid(text) {
          this.input.setAttribute('aria-invalid', 'true');
          this.message(text, 'error');
          this.input.focus();
        }

        // Shopify answers the POST with a redirect to the same page; we read the result from that page
        async submit(event) {
          if (this.form.dataset.native === '1') return;
          event.preventDefault();
          if (this.hasAttribute('data-busy')) return;

          const email = this.input.value.trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
            this.invalid(this.dataset.invalid || 'Email is invalid');
            return;
          }

          this.setAttribute('data-busy', '');
          try {
            const response = await fetch(this.form.getAttribute('action'), {
              method: 'POST',
              body: new FormData(this.form),
              credentials: 'same-origin',
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            if (!response.ok || response.url.indexOf('/challenge') > -1) throw new Error('native');

            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const posted = doc.getElementById(this.form.id);
            if (posted && posted.querySelector('[data-on-ft-success]')) {
              this.message(this.dataset.success || 'Thanks for subscribing', 'success');
              this.setAttribute('data-state', 'success');
              this.removeAttribute('data-open');
              document.dispatchEvent(new CustomEvent('on:newsletter-subscribed', { detail: { email: email } }));
            } else if (posted && posted.querySelector('[data-on-ft-error]')) {
              this.invalid(posted.querySelector('[data-on-ft-error]').textContent.trim() || this.dataset.error);
            } else {
              throw new Error('native');
            }
          } catch (error) {
            // spam check, network hiccup, unknown answer: let the browser do a normal submit instead
            this.form.dataset.native = '1';
            this.form.submit();
            return;
          }
          this.removeAttribute('data-busy');
        }
      }
    );
  }

  if (!customElements.get('on-footer-region')) {
    customElements.define(
      'on-footer-region',
      class OnFooterRegion extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-on-ft-dialog]');
          this.opener = this.querySelector('[data-on-ft-region-open]');
          if (!this.dialog || !this.opener || typeof this.dialog.showModal !== 'function') return;

          this.onOpen = () => this.dialog.showModal();
          this.onClick = (event) => {
            if (event.target.closest('[data-on-ft-region-close]') || event.target === this.dialog) this.dialog.close();
          };
          this.opener.addEventListener('click', this.onOpen);
          this.dialog.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          if (!this.opener) return;
          this.opener.removeEventListener('click', this.onOpen);
          this.dialog.removeEventListener('click', this.onClick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('on-hero-slider')) {
    customElements.define(
      'on-hero-slider',
      class OnHeroSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-ohs-track]');
          this.slides = Array.from(this.querySelectorAll('[data-ohs-slide]'));
          if (!this.track || !this.slides.length) return;

          this.bars = Array.from(this.querySelectorAll('[data-ohs-bar]'));
          this.barsWrap = this.querySelector('[data-ohs-bars]');
          this.prevBtn = this.querySelector('[data-ohs-prev]');
          this.nextBtn = this.querySelector('[data-ohs-next]');
          this.pauseBtn = this.querySelector('[data-ohs-pause]');

          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.reduce;
          if (!this.autoplay) this.setAttribute('data-autoplay', 'false');
          this.pauseOnHover = this.dataset.pauseHover !== 'false';

          this.index = 0;
          this.lockUntil = 0;
          this.drag = null;
          this.suppressClick = false;
          this.settleTimer = null;
          this.restore = null;
          this.frame = null;
          this.flags = { user: false, hover: false, focus: false, hidden: document.hidden, offscreen: false };

          this.onScroll = () => this.schedule();
          this.onBarClick = (event) => {
            const bar = event.target.closest('[data-ohs-bar]');
            if (bar) this.goTo(this.bars.indexOf(bar));
          };
          this.onPrev = () => this.goTo(this.index - 1);
          this.onNext = () => this.goTo(this.index + 1);
          this.onPauseClick = () => this.setUserPaused(!this.flags.user);
          this.onAnimationEnd = (event) => {
            const bar = event.target.closest ? event.target.closest('[data-ohs-bar]') : null;
            if (event.animationName === 'ohs-fill' && bar && bar.classList.contains('is-active') && this.autoplay) {
              this.goTo(this.index + 1);
            }
          };
          this.onKey = (event) => this.keyDown(event);
          this.onEnter = (event) => {
            if (this.pauseOnHover && event.pointerType === 'mouse') this.setFlag('hover', true);
          };
          this.onLeave = (event) => {
            if (event.pointerType === 'mouse') this.setFlag('hover', false);
          };
          this.onFocusIn = (event) => {
            let keyboard = true;
            try {
              keyboard = event.target.matches(':focus-visible');
            } catch (error) {
              keyboard = true;
            }
            if (keyboard) this.setFlag('focus', true);
          };
          this.onFocusOut = () => this.setFlag('focus', false);
          this.onVisibility = () => this.setFlag('hidden', document.hidden);
          this.onPointerDown = (event) => this.dragStart(event);
          this.onPointerMove = (event) => this.dragMove(event);
          this.onPointerUp = () => this.dragEnd();
          this.onDragStart = (event) => event.preventDefault();
          this.onClickCapture = (event) => {
            if (!this.suppressClick) return;
            event.preventDefault();
            event.stopPropagation();
            this.suppressClick = false;
          };

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('keydown', this.onKey);
          this.track.addEventListener('pointerdown', this.onPointerDown);
          this.track.addEventListener('dragstart', this.onDragStart);
          this.track.addEventListener('click', this.onClickCapture, true);
          if (this.barsWrap) {
            this.barsWrap.addEventListener('click', this.onBarClick);
            this.barsWrap.addEventListener('animationend', this.onAnimationEnd);
          }
          if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
          if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
          if (this.pauseBtn) this.pauseBtn.addEventListener('click', this.onPauseClick);
          this.addEventListener('pointerenter', this.onEnter);
          this.addEventListener('pointerleave', this.onLeave);
          this.addEventListener('focusin', this.onFocusIn);
          this.addEventListener('focusout', this.onFocusOut);
          document.addEventListener('visibilitychange', this.onVisibility);

          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver(
              (entries) => this.setFlag('offscreen', !entries[0].isIntersecting),
              { threshold: 0.35 }
            );
            this.io.observe(this);
          }
          this.resizeObserver = new ResizeObserver(() => this.snapToIndex());
          this.resizeObserver.observe(this.track);

          this.setActive(0, true);
          // the first slide already carries is-entering from the markup; just clear it once it has played
          this.slides[0]._enterTimer = setTimeout(() => this.slides[0].classList.remove('is-entering'), 2600);
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('keydown', this.onKey);
          this.track.removeEventListener('pointerdown', this.onPointerDown);
          this.track.removeEventListener('dragstart', this.onDragStart);
          this.track.removeEventListener('click', this.onClickCapture, true);
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          document.removeEventListener('visibilitychange', this.onVisibility);
          if (this.io) this.io.disconnect();
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          clearTimeout(this.settleTimer);
          clearTimeout(this.fadeTimer);
          this.slides.forEach((slide) => clearTimeout(slide._enterTimer));
        }

        /* ---------- Geometry ---------- */
        width() {
          return this.track.clientWidth || 1;
        }
        sign() {
          return getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        }

        /* ---------- Active slide ---------- */
        schedule() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            if (Date.now() < this.lockUntil || this.drag) return;
            const index = Math.round(Math.abs(this.track.scrollLeft) / this.width());
            const clamped = Math.max(0, Math.min(this.slides.length - 1, index));
            if (clamped !== this.index) this.setActive(clamped);
          });
        }

        setActive(index, initial = false) {
          const changed = index !== this.index;
          this.index = index;
          this.slides.forEach((slide, i) => {
            const on = i === index;
            slide.classList.toggle('is-active', on);
            slide.inert = !on;
          });
          this.bars.forEach((bar, i) => {
            bar.classList.toggle('is-active', i === index);
            if (i === index) bar.setAttribute('aria-current', 'true');
            else bar.removeAttribute('aria-current');
          });
          this.syncVideos();
          this.updatePaused();
          // swipe, drag, arrows, progress bars and autoplay all end up here: replay the text + button entrance
          if (changed && !initial) this.enterSlide(this.slides[index]);
        }

        snapToIndex() {
          if (this.drag || Date.now() < this.lockUntil) return;
          this.track.scrollTo({ left: this.sign() * this.index * this.width(), behavior: 'auto' });
        }

        // Replays the text + button entrance on a slide
        enterSlide(slide) {
          if (!slide || this.reduce) return;
          clearTimeout(slide._enterTimer);
          slide.classList.remove('is-entering');
          void slide.offsetWidth;
          slide.classList.add('is-entering');
          slide._enterTimer = setTimeout(() => slide.classList.remove('is-entering'), 2600);
        }

        goTo(target) {
          const count = this.slides.length;
          if (count < 2) return;
          const wraps = target < 0 || target >= count;
          const next = (target + count) % count;
          if (next === this.index && !wraps) return;
          this.lockUntil = Date.now() + 900;
          this.setActive(next);

          if (wraps && !this.reduce) {
            // Going from the last slide to the first (or back): fade, jump, fade in. No fast rewind.
            this.track.classList.add('is-fading');
            clearTimeout(this.fadeTimer);
            this.fadeTimer = setTimeout(() => {
              this.track.scrollTo({ left: this.sign() * next * this.width(), behavior: 'auto' });
              this.track.classList.remove('is-fading');
              this.enterSlide(this.slides[next]);
            }, 320);
          } else {
            this.track.scrollTo({
              left: this.sign() * next * this.width(),
              behavior: this.reduce ? 'auto' : 'smooth'
            });
          }
        }

        /* ---------- Autoplay pausing ---------- */
        setFlag(name, value) {
          this.flags[name] = value;
          this.updatePaused();
        }

        setUserPaused(value) {
          this.flags.user = value;
          if (!value) {
            this.flags.focus = false;
            this.flags.hover = false;
          }
          if (this.pauseBtn) {
            this.pauseBtn.setAttribute('aria-pressed', value ? 'true' : 'false');
            this.pauseBtn.setAttribute('aria-label', value ? 'Play slideshow' : 'Pause slideshow');
          }
          this.updatePaused();
        }

        updatePaused() {
          const f = this.flags;
          const paused = f.user || f.hover || f.focus || f.hidden || f.offscreen;
          this.toggleAttribute('data-paused', paused);
          this.syncVideos();
        }

        /* ---------- Videos: only the active slide, only the visible device ---------- */
        syncVideos() {
          if (!this.slides) return;
          const allow = !this.reduce && !this.flags.user && !this.flags.hidden && !this.flags.offscreen;
          this.slides.forEach((slide, i) => {
            slide.querySelectorAll('video').forEach((video) => {
              const visible = video.offsetParent !== null || video.getClientRects().length > 0;
              if (i === this.index && visible && allow) {
                const promise = video.play();
                if (promise && promise.catch) promise.catch(() => {});
              } else {
                video.pause();
              }
            });
          });
        }

        /* ---------- Keyboard ---------- */
        keyDown(event) {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          const rtl = this.sign() === -1;
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.index + (rtl ? -1 : 1));
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.index + (rtl ? 1 : -1));
          } else if (event.key === 'Home') {
            event.preventDefault();
            this.goTo(0);
          } else if (event.key === 'End') {
            event.preventDefault();
            this.goTo(this.slides.length - 1);
          }
        }

        /* ---------- Mouse drag (touch swipes natively with scroll-snap) ---------- */
        dragStart(event) {
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.slides.length < 2) return;
          if (event.target.closest('a, button')) return;
          this.suppressClick = false;
          this.drag = { x: event.clientX, scroll: this.track.scrollLeft, moved: false, lastX: event.clientX, lastT: performance.now(), velocity: 0 };
          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);
        }

        dragMove(event) {
          const d = this.drag;
          if (!d) return;
          const dx = event.clientX - d.x;
          if (!d.moved) {
            if (Math.abs(dx) < 5) return;
            d.moved = true;
            this.cancelSettle();
            this.track.classList.add('is-dragging');
            this.track.style.scrollSnapType = 'none';
          }
          const now = performance.now();
          const dt = now - d.lastT;
          if (dt > 0) {
            d.velocity = 0.7 * d.velocity + 0.3 * ((event.clientX - d.lastX) / dt);
            d.lastX = event.clientX;
            d.lastT = now;
          }
          this.track.scrollLeft = d.scroll - dx;
        }

        dragEnd() {
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          const d = this.drag;
          this.drag = null;
          if (!d || !d.moved) return;

          this.track.classList.remove('is-dragging');
          this.suppressClick = true;

          const sign = this.sign();
          const velocity = performance.now() - d.lastT > 80 ? 0 : d.velocity;
          const moving = -velocity * sign;
          let position = Math.abs(this.track.scrollLeft) / this.width();
          if (Math.abs(moving) > 0.35) position = moving > 0 ? Math.ceil(position) : Math.floor(position);
          else position = Math.round(position);
          const target = Math.max(0, Math.min(this.slides.length - 1, position));

          this.lockUntil = Date.now() + 700;
          this.setActive(target);
          this.track.scrollTo({ left: sign * target * this.width(), behavior: this.reduce ? 'auto' : 'smooth' });
          this.settle();
        }

        settle() {
          const track = this.track;
          this.cancelSettle();
          this.restore = () => {
            this.cancelSettle();
            track.style.scrollSnapType = '';
          };
          track.addEventListener('scrollend', this.restore, { once: true });
          this.settleTimer = setTimeout(this.restore, 700);
        }

        cancelSettle() {
          clearTimeout(this.settleTimer);
          this.settleTimer = null;
          if (this.restore) {
            this.track.removeEventListener('scrollend', this.restore);
            this.restore = null;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-pdp-accordions"] && !Shopify.designMode) return;
  try {
    
  /* "Size Chart" shortcut: open the Size & Fit accordion on this page and scroll to it */
  (function () {
    if (window.__onSizeChartShortcut) return;
    window.__onSizeChartShortcut = true;

    function openSizeChart() {
      var accordion = document.querySelector('details[data-on-size-chart]');
      if (!accordion) return false;

      accordion.open = true;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      accordion.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });

      var summary = accordion.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
      return true;
    }

    // 1. the drawer's "Size Chart" link (cancelable event: preventDefault = "handled")
    document.addEventListener('on:size-chart-open', function (event) {
      if (openSizeChart()) event.preventDefault();
    });

    // 2. any link / button that points at the size chart
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest('a[href="#on-size-chart"], [data-open-size-chart]') : null;
      if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (openSizeChart()) event.preventDefault();
    });

    // 3. a page opened with #on-size-chart
    function fromHash() {
      if (window.location.hash === '#on-size-chart') openSizeChart();
    }
    window.addEventListener('hashchange', fromHash);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash);
    else fromHash();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-seo-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('on-seo-footer')) {
    customElements.define(
      'on-seo-footer',
      class OnSeoFooter extends HTMLElement {
        connectedCallback() {
          if (!this.hasAttribute('data-clamp')) return;

          this.desc = this.querySelector('[data-osf-desc]');
          this.toggle = this.querySelector('[data-osf-toggle]');
          if (!this.desc || !this.toggle) return;

          this.expanded = false;
          this.onClick = () => this.setExpanded(!this.expanded);
          this.toggle.addEventListener('click', this.onClick);

          this.setAttribute('data-ready', '');
          this.resizeObserver = new ResizeObserver(() => this.measure());
          this.resizeObserver.observe(this.desc);
          this.measure();
        }

        disconnectedCallback() {
          if (this.toggle && this.onClick) this.toggle.removeEventListener('click', this.onClick);
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        setExpanded(expanded) {
          this.expanded = expanded;
          this.desc.classList.toggle('is-expanded', expanded);
          this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          this.toggle.textContent = expanded ? this.toggle.dataset.less : this.toggle.dataset.more;
          this.measure();
          if (!expanded) this.toggle.scrollIntoView({ block: 'nearest' });
        }

        measure() {
          const desc = this.desc;
          if (this.expanded) {
            desc.classList.remove('is-clamped');
            this.toggle.hidden = false;
            return;
          }
          const overflows = desc.scrollHeight - desc.clientHeight > 1;
          desc.classList.toggle('is-clamped', overflows);
          this.toggle.hidden = !overflows;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
